import { memo, useEffect } from 'react';
import { useAtom } from 'jotai';

import { showMeetingsAtom } from '../meetings/messages';
import AppTools from '../tools/components/AppTools/AppTools';
import useIsMobile from '../hooks/useIsMobile';

type Props = {
    tool: string;
    eventUniqueName: string;
};

// TODO: configure that with the Zendesk solution
declare global {
    interface Window {
        zE?: (a: string, b: string) => void;
    }
}

const ToolSide: React.FC<Props> = ({ eventUniqueName }) => {
    const [showMeetings] = useAtom(showMeetingsAtom);
    const isMobile = useIsMobile();

    useEffect(() => {
        if (window.zE && isMobile && showMeetings) {
            window.zE('webWidget', 'hide');
        } else if (window.zE && isMobile && !showMeetings) {
            window.zE('webWidget', 'show');
        }
    }, [isMobile, showMeetings]);

    return <AppTools eventUniqueName={eventUniqueName} />;
};

export default memo(ToolSide);
